import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';

import {
  CountryActionsUnion,
  CountryActionTypes
} from '@core/actions/country.actions';
import { Country } from '@app/models/country';
import { comparerByAlphabet } from '@app/comparers';

export interface State extends EntityState<Country> {
  loading: boolean;
  loaded: boolean;
  selectedId: number;
}

export const adapter: EntityAdapter<Country> = createEntityAdapter<Country>({
  selectId: (country: Country) => country.id,
  sortComparer: comparerByAlphabet('ASC', 'name')
});

export const INITIAL_STATE: State = adapter.getInitialState({
  loading: false,
  loaded: false,
  selectedId: null
});

export function reducer(
  state: State = INITIAL_STATE,
  action: CountryActionsUnion
) {
  switch (action.type) {
    case CountryActionTypes.Load:
      return { ...state, loading: true };

    case CountryActionTypes.LoadFail:
      return { ...state, loading: false };

    case CountryActionTypes.LoadSuccess:
      return adapter.addAll(action.countries, {
        ...state,
        loading: false,
        loaded: true
      });

    case CountryActionTypes.Select:
      return { ...state, selectedId: action.id };

    default:
      return state;
  }
}

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal
} = adapter.getSelectors();

export const selectLoaded = (state: State) => state.loaded;
export const selectLoading = (state: State) => state.loading;
export const selectSelectedId = (state: State) => state.selectedId;
